import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import { PartialUser, PartialEntity } from '@apps/back/models';
import {
    BackEntityDetailsSelectSet,
    BackEntityDetailsWasSelected,
    BackUserDetailsLoadRequested,
    BackUserDetailsLoadSucceeded
} from './misc.actions';
import { User } from '@apps/auth/domain/models/back';

@Injectable()
export class BackMiscEffects
{
    constructor (
        private actions: Actions
    )
    {}

    backUserDetailsLoadRequested = createEffect(
        () =>
            this.actions
                .pipe(
                    ofType(BackUserDetailsLoadRequested),
                    map(({ user }: {user: User }) =>
                    {
                        return BackUserDetailsLoadSucceeded({ user: PartialUser.mapperFromUser(user) });
                    })
                )
    );

    backEntityDetailsSelectedSet = createEffect(
        () =>
            this.actions
                .pipe(
                    ofType(BackEntityDetailsSelectSet),
                    map(({ entity }) =>
                    {
                        return BackEntityDetailsWasSelected({ entity: PartialEntity.mapperFromEntity(entity) });
                    })
                )
    );

}